/** @jsx jsx */
import { css } from '@emotion/core';
import { colorsPalette } from '../../../styles/colors';
import { MediaQueries } from '../../../styles/Grid';
import { typography } from '../../../styles/typography';

export const containerMarginCss = css({
  margin: '64px 0',
  [MediaQueries.mdAndUp]: {
    margin: '160px 0',
  },
});

export const quoteTextCss = css(typography.effra34, {
  marginBottom: 28,
  position: 'relative',
  left: 16,
  [MediaQueries.mdAndUp]: {
    marginBottom: 16,
    left: 0,
  },
  [MediaQueries.lgAndUp]: {
    marginTop: 56,
  },
});

export const initialQuote = css({
  position: 'absolute',
  left: -16,
});

export const blockquoteCss = css({
  [MediaQueries.mdAndUp]: {
    paddingLeft: 16,
  },
});

export const attributionCss = css({
  alignItems: 'center',
  display: 'flex',
  height: 60,
  marginBottom: 40,
  position: 'relative',
  left: 16,
  [MediaQueries.mdAndUp]: {
    marginBottom: 32,
    left: 0,
  },
});

export const headshotCss = css({
  marginRight: 15,
  borderRadius: '50%',
  display: 'inline-block',
  height: 40,
  width: 40,
  overflow: 'hidden',
});

export const imageCss = css({
  height: 40,
  width: 40,
});

export const attributionMainTextCss = css({
  color: colorsPalette.teal,
  marginBottom: 7,
});

export const attributionSecondaryTextCss = css({
  color: colorsPalette.grey80,
});

export const readTheFullStoryCtaCss = css({
  marginBottom: 64,
  [MediaQueries.mdAndUp]: {
    marginBottom: 40,
    width: 215,
  },
  [MediaQueries.lgAndUp]: {
    marginBottom: 1,
  },
});

export const carouselColumnCss = css({
  maxWidth: '100%',
});

export const spacerCss = css({
  overflow: 'hidden',
});

export const ctaContainer = css({
  padding: '0 1px',
});

export const carouselCss = css({
  ul: {
    width: 910,
    position: 'initial',
    display: 'flex',
    flexDirection: 'row',
  },
});
